import initMobileMenu from './modules/mobile-menu';
import initDesktopSubmenu from './modules/desktop-submenu';
import initAccordion from './modules/accordion';
import initTestimonials from './modules/testimonials';
import initHero from './modules/hero';
import initIntroStatement from './modules/intro-statement';
import initVideoLightbox from './modules/video-lightbox';
import initWhyProvidence from './modules/why-providence';
import initExploreCta from './modules/explore-cta';
import initTabbed from './modules/tabbed';
import initScrollingTwoColumn from './modules/scrolling-two-column';
import initResourcePage from './modules/resource-page';
import initResourceElement from './modules/resource-element';
import initContactTabs from './modules/contact-tabs';
import initScrollingGallery from './modules/scrolling-gallery';
import initScrollingImageGallery from './modules/scrolling-image-gallery';
import initImageSlider from './modules/image-slider';

function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(() => {
    initMobileMenu();
    initDesktopSubmenu();
    initAccordion();
    initTestimonials();
    initHero();
    initIntroStatement();
    initVideoLightbox();
    initWhyProvidence();
    initExploreCta();
    initTabbed();
    initScrollingTwoColumn();
    initResourcePage();
    initResourceElement();
    initContactTabs();
    initScrollingGallery();
    initScrollingImageGallery();
    initImageSlider();
});
